import { StyleSheet } from "react-native";
import { hs, isPhone, vs } from '@/Utils/Dimensions';
import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';

export const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(20,18,16,0.6)',
  },
  modalView: {
    width: isPhone ? '90%' : 400,
    backgroundColor: CCColors.White,
    borderRadius: 20,
    overflow: 'hidden',
    alignItems: 'center',
    shadowColor: CCColors.Black,
    shadowOffset: {width: 0, height: 10},
    shadowOpacity: 0.2,
    shadowRadius: 28,
    elevation: 14,
  },
  headerStrip: {
    width: '100%',
    height: vs(6),
    backgroundColor: CCColors.Buttons.Background,
  },
  contentWrapper: {
    width: '100%',
    alignItems: 'center',
    paddingHorizontal: hs(24),
    paddingTop: vs(20),
    paddingBottom: vs(22),
  },
  imageWrapper: {
    width: hs(130),
    height: vs(130),
    borderRadius: hs(65),
    backgroundColor: updateColorWithOpacity(CCColors.Buttons.Background, 0.12),
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: vs(16),
    position: 'relative',
  },
  challengerText: {
    color: CCColors.TextColor.Dark,
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: vs(4),
  },
  gameDetailsText: {
    color: CCColors.TextColor.Primary,
    textAlign: 'center',
    marginBottom: vs(16),
  },
  ratingsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: hs(12),
    marginBottom: vs(16),
    width: '100%',
  },
  ratingBox: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: updateColorWithOpacity(CCColors.Buttons.Background, 0.12),
    borderWidth: 1,
    borderColor: updateColorWithOpacity(CCColors.Buttons.Background, 0.5),
    borderRadius: 12,
    paddingVertical: vs(10),
    paddingHorizontal: hs(8),
  },
  ratingBoxLabel: {
    color: CCColors.TextColor.GreyText,
    fontWeight: '500',
    marginBottom: vs(2),
    textAlign: 'center',
  },
  ratingBoxValue: {
    color: CCColors.TextColor.Dark,
    fontWeight: '800',
    textAlign: 'center',
  },
  vsCircle: {
    width: hs(36),
    height: hs(36),
    borderRadius: hs(18),
    backgroundColor: CCColors.Buttons.Background,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: CCColors.Buttons.Background,
    shadowOffset: {width: 0, height: 3},
    shadowOpacity: 0.4,
    shadowRadius: 6,
    elevation: 4,
  },
  vsText: {
    color: CCColors.TextColor.Dark,
    fontWeight: '800',
  },
  progressBarWrapper: {
    width: '100%',
    marginBottom: vs(6),
  },
  progressTrack: {
    width: '100%',
    height: vs(4),
    backgroundColor: 'rgba(0,0,0,0.08)',
    borderRadius: 99,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    borderRadius: 99,
  },
  countdownText: {
    textAlign: 'center',
  },
  buttonRow: {
    gap: hs(10),
    width: '100%',
    marginTop: vs(4),
  },
  btnReject: {
    flex: 1,
  },
  btnAccept: {
    flex: 1.4,
  },
  button: {borderRadius: 20, padding: 10, elevation: 2},
  buttonOpen: {backgroundColor: '#F194FF'},
  buttonClose: {backgroundColor: '#2196F3'},
  textStyle: {color: 'white', fontWeight: 'bold', textAlign: 'center'},
  modalText: {marginBottom: 15, textAlign: 'center'},
});
